// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__dGWov","copyleft":"footer_copyleft__Utqqb","icon":"footer_icon__bRScJ"};